import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { sendAnalytics } from '../../../scripts/analytics/tracker';
import manageTracking from '../../../scripts/analytics/creators/manage';

import TranslatedCopy from '../../intl/translated-copy';

import aircraftError from '../../../images/aircraft-error.svg';

const mapStateToProps = state => ({
  isActiveFlowCorporate: state.Corporate.isActiveFlowCorporate,
  transactionId: state?.Manage?.confirmationModel?.transactionId,
});

function BlueWindow(props) {
  const {
    contactNumber,
    dispatch,
    errorInfo,
    errorUI,
    isActiveFlowCorporate,
    transactionId,
  } = props;

  useEffect(() => {
    if (errorUI) {
      sendErrorUIMetric(dispatch, errorUI, errorInfo, transactionId);
    }
  }, []);

  const formatContactNumber = `tel:${contactNumber}`;

  return (
    <div className='BlueWindow'>
      <div className='BlueWindow-content'>
        <div>
          <div>
            <header className='BlueWindow-header'>
              <div className='BlueWindow-img'>
                <img alt='Error Icon' className='ResponsiveImage '
                  src={ aircraftError } title='' />
              </div>
              <h1 className='BlueWindow-title'>
                <TranslatedCopy copyID='MYB_MODAL_ERROR_OH_NO'/><br />
                <TranslatedCopy copyID='MYB_MODAL_ERROR_TITLE' />
              </h1>
            </header>
            <div className='BlueWindow-body'>
              <div className='BlueWindow-description'>
                <span>
                  <TranslatedCopy
                    className='u-textLarge'
                    copyID='MYB_MODAL_ERROR_SUBTITLE' />
                </span>
              </div>
              <section className='BlueWindow-callCenter'>
                <p className='BlueWindow-callCenter--description'>
                  <TranslatedCopy copyID='MYB_MODAL_ERROR_CALLUS' spaceAfter={ true } />
                  <a className='BlueWindow-callCenter--contactNumber' href={ formatContactNumber }>
                    { isActiveFlowCorporate ?
                      <TranslatedCopy copyID='C&C_Corp_CallCenterNumer' />
                      :
                      contactNumber
                    }
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function sendErrorUIMetric(dispatch, errorUI, errorLocationUI, transactionId) {
  const debuggingStuffHere = `${ errorUI?.stack || '' }${ errorLocationUI?.componentStack || '' }`;

  const errorInfo = {
    actionType: 'UI-Error',
    errorData: {
      code: 'UI-Error',
      actionable: 'ABORT',
      msg: errorUI?.message || null,
      extraInfo: {
        'debugging_stuff_here': debuggingStuffHere,
      },
    },
  };
  dispatch(sendAnalytics({
    eventCreator: !transactionId
      ? manageTracking.errorTracking(errorInfo) 
      : manageTracking.errorTracking(errorInfo, 'confirmation'),
  }));
}

BlueWindow = connect(mapStateToProps)(BlueWindow);

export default BlueWindow;
